
import { Observable } from '../../Observable';
import { defaultIfEmpty } from '../../operator/defaultIfEmpty';

Observable.prototype.defaultIfEmpty = defaultIfEmpty;

declare module '../../Observable' {
  interface Observable<T> {
    defaultIfEmpty: typeof defaultIfEmpty;
  }
}


// WEBPACK FOOTER //
// ../../../src/add/operator/defaultIfEmpty.ts